import { create } from 'zustand';

import {
    sendLoadingUpdate
} from '../channels/loadingChannel';

export const useLoadingStore = create((set) => ({
    
    loading: true,

    loadingTrips: true,

    loadingLines: true,

    loadingVehicles: true,

    loadingDrivers: true,

    loadingClients: true,

    loadingBackdrop: false,

    loadingFooter: false,

    loadingFooterTxt: 'Carregando...',

    loadingTxt: 'Carregando...',

    loadProgress: 0,

    setLoading: (
        loading,
        broadcast = true
    ) => {

        set({ loading });

        if (broadcast) {
            sendLoadingUpdate({
                loading
            });
        }
    },

    setLoadingTrips: (
        loadingTrips,
        broadcast = true
    ) => {

        set({ loadingTrips });

        if (broadcast) {
            sendLoadingUpdate({
                loadingTrips
            });
        }
    },

    setLoadingLines: (
        loadingLines,
        broadcast = true
    ) => {

        set({ loadingLines });

        if (broadcast) {
            sendLoadingUpdate({
                loadingLines
            });
        }
    },

    setLoadingVehicles: (
        loadingVehicles,
        broadcast = true
    ) => {

        set({ loadingVehicles });

        if (broadcast) {
            sendLoadingUpdate({
                loadingVehicles
            });
        }
    },

    setLoadingDrivers: (
        loadingDrivers,
        broadcast = true
    ) => {

        set({ loadingDrivers });

        if (broadcast) {
            sendLoadingUpdate({
                loadingDrivers
            });
        }
    },

    setLoadingClients: (
        loadingClients,
        broadcast = true
    ) => {

        set({ loadingClients });

        if (broadcast) {
            sendLoadingUpdate({
                loadingClients
            });
        }
    },

    setLoadingBackdrop: (
        loadingBackdrop,
        broadcast = true
    ) => {

        set({ loadingBackdrop });

        if (broadcast) {
            sendLoadingUpdate({
                loadingBackdrop
            });
        }
    },

    setLoadingFooter: (
        loadingFooter
    ) => {

        set({ loadingFooter });
    },

    setLoadingFooterTxt: (
        loadingFooterTxt
    ) => {

        set({ loadingFooterTxt });
    },

    setLoadingTxt: (
        loadingTxt,
        broadcast = true
    ) => {

        set({ loadingTxt });

        if (broadcast) {
            sendLoadingUpdate({
                loadingTxt
            });
        }
    },

    setLoadProgress: (
        loadProgress,
        broadcast = true
    ) => {

        set({ loadProgress });

        if (broadcast) {
            sendLoadingUpdate({
                loadProgress
            });
        }
    },

    startLoading: (
        loadingTxt = 'Carregando...',
        broadcast = true
    ) => {

        const state = {
            loading: true,
            loadingTxt
        };

        set(state);

        if (broadcast) {
            sendLoadingUpdate(state);
        }
    },

    stopLoading: (
        broadcast = true
    ) => {

        const state = {
            loading: false,
            loadingTxt: '',
            loadingBackdrop: false
        };

        set(state);

        if (broadcast) {
            sendLoadingUpdate(state);
        }
    },

    applyLoadingState: (state = {}) => {
        set(state);
    }

}));

export const selectIsMainLoading = state =>
    state.loadingClients ||
    state.loadingVehicles ||
    state.loadingDrivers ||
    state.loadingLines ||
    state.loadingTrips;